import { Accounting, Angularjs, Chicago, Commission, ComputerSoftware, Contract, FinancialServices, Frontenddesigner, Fulltime, GraphicDesigner, GulpPug, ITEngineer, Internship, Javascript, NewYork, Nodejs, PHPdeveloper, Parttime, ReactDeveloper, SanFrancisco, Seattle, Serviceindustry, Temporary, UIUxdesigner, Washington, Htmlcss } from "../../utils/Constant";

export let checkBoxData = [
    { inputTittle: Fulltime, inputNumber: "(8688)" },
    { inputTittle: Contract, inputNumber: "(503)" },
    { inputTittle: Parttime, inputNumber: "(288)" },
    { inputTittle: Internship, inputNumber: "(236)" },
    { inputTittle: Temporary, inputNumber: "(146)" },
    { inputTittle: Commission, inputNumber: "(25)" },
  ];
  export const locationCheckBoxData = [
    { location: NewYork, locationSpanText: "NY (399)" },
    { location: SanFrancisco, locationSpanText: "CA (252)" },
    { location: Washington, locationSpanText: "DC (226)" },
    { location: Seattle, locationSpanText: "WA (242)" },
    { location: Chicago, locationSpanText: "IL (187)" },
  ];

  export const jobTitleCheckBoxData = [
    { JobTitle: UIUxdesigner, JobNumber: 25 },
    { JobTitle: GraphicDesigner, JobNumber: 10 },
    { JobTitle: Frontenddesigner, JobNumber: 15 },
    { JobTitle: PHPdeveloper, JobNumber: 42 },
    { JobTitle: ReactDeveloper, JobNumber: 5 },
  ];

  export const industryCheckBoxData = [
    { industryTitle: ComputerSoftware, industryNumber: 14 },
    { industryTitle: ITEngineer, industryNumber: 10 },
    { industryTitle: Serviceindustry, industryNumber: 20 },
    { industryTitle: Accounting, industryNumber: 34 },
    { industryTitle: FinancialServices, industryNumber: 5 },
  ];

  export const skillCheckBoxData = [
    Htmlcss,
    Javascript,
    Nodejs,
    GulpPug,
    Angularjs,
  ];

  export const jobData = [
    {
      id: 1,
      logo: "job-search/1.jpg",
      job_name: "UI/UX IT Frontend Developer",
      badgeType: "primary",
      badgeValue: "New",
      job_area: "(L6) Salt Lake City",
      job_city: "UT",
      Job_description:
        "The designer will apply Lean UX and Design Thinking practices in a highly collaborative, fast-paced, distributed environment You have 4+ years of UX experience. You support UX leadership by providing continuous feedback regarding the evolution of team process standards.",
      type: "new",
      ribbion: false,
    },
    {
      id: 2,
      logo: "job-search/2.jpg",
      job_name: "React/React Native Developer",
      badgeType: "primary",
      badgeValue: "New",
      job_area: "San Diego",
      job_city: "CA",
      Job_description:
        "Insipidity the sufficient discretion imprudence decisively. Proceed how visitor. Explained propriety off out perpetual his you. Feel sold off felt nay rose met you. We so entreaties cultivated astonished is. Was sister for few longer mrs sudden talent become.",
      type: "new",
      ribbion: false,
    },
    {
      id: 3,
      logo: "job-search/3.jpg",
      job_name: "Senior UX designer",
      job_area: "Minneapolis",
      job_city: "MN",
      Job_description:
        "Contented get distrusts certainty nay are frankness concealed ham. On unaffected resolution on considered of. No thought me husband forming effects. End sitting shewing who saw besides son musical adapted. Contrasted interested eat alteration pianoforte sympathize was.",
      type: "2 days ago",
      ribbion: true,
    },
    {
      id: 4,
      logo: "job-search/4.jpg",
      job_name: "Front end web developer",
      badgeType: "primary",
      badgeValue: "New",
      job_area: "Cisco",
      job_city: "Lelystad, Netherlands",
      Job_description:
        "Situation admitting promotion at or to perceived be. Mr acuteness we as estimable enjoyment up. An held late as felt know. Learn do allow solid to grave. Middleton suspicion age her attention. Chiefly several bed its wishing. Is so moments on chamber pressed to. Doubtful yet way properly answered.",
      type: "3 days ago",
      ribbion: false,
    },
    {
      id: 5,
      logo: "job-search/5.jpg",
      job_name: "Graphic designer",
      badgeType: "primary",
      badgeValue: "New",
      job_area: "Infosys",
      job_city: "Lelystad, Netherlands",
      Job_description:
        "The designer will apply Lean UX and Design Thinking practices in a highly collaborative, fast-paced, distributed environment You have 4+ years of UX experience. You support UX leadership by providing continuous feedback regarding the evolution of team process standards.",
      type: "3 days ago",
      ribbion: false,
    },
    {
      id: 6,
      logo: "job-search/6.jpg",
      job_name: "Designer, CRM",
      badgeType: "primary",
      badgeValue: "New",
      job_area: "Citrix",
      job_city: "Lelystad, Netherlands",
      Job_description:
        "You have 4+ years of UX experience. You support UX leadership by providing continuous feedback regarding the evolution of team process standards. The designer will apply Lean UX and Design Thinking practices in a highly collaborative, fast-paced, distributed environment.",
      type: "5 days ago",
      ribbion: false,
    },
    {
      id: 7,
      logo: "job-search/2.jpg",
      job_name: "React/React Native Developer",
      job_area: "San Diego",
      job_city: ",CA",
      Job_description:
        "We are looking for an experienced and zeta designer and/or frontend engineer with expertise in accessibility to join our team , 3+ years of experience working in as a Frontend Engineer or comparable role.",
      type: "5 days ago",
      ribbion: true,
    },
    {
      id: 8,
      logo: "job-search/3.jpg",
      job_name: "Senior UX designer",
      badgeType: "primary",
      badgeValue: "New",
      job_area: "Minneapolis",
      job_city: "MN",
      Job_description:
        "3+ years of experience working in as a Frontend Engineer or comparable role. we are looking for an experienced and zeta designer and/or frontend engineer with expertise in accessibility to join our team.",
      type: "5 days ago",
      ribbion: false,
    },
    {
      id: 9,
      logo: "job-search/5.jpg",
      job_name: "Graphic designer",
      badgeType: "primary",
      badgeValue: "New",
      job_area: "Infosys",
      job_city: "Lelystad, Netherlands ",
      Job_description:
        "Insipidity the sufficient discretion imprudence resolution decisively. Proceed how visitor. Explained propriety off out perpetual his you. Feel sold off felt nay rose met you. We so entreaties cultivated astonished is. Was sister for few longer mrs sudden talent become.",
      type: "3 days Ago",
      ribbion: false,
    },
    {
      id: 10,
      logo: "job-search/1.jpg",
      job_name: "Designer, CRM",
      badgeType: "primary",
      badgeValue: "New",
      job_area: "Citrix",
      job_city: "Lelystad, Netherlands",
      Job_description:
        "The designer will apply Lean UX and Design Thinking practices in a highly collaborative, fast-paced, distributed environment You have 4+ years of UX experience. You support UX leadership by providing continuous feedback regarding the evolution of team process standards.",
      type: "3 days Ago",
      ribbion: false,
    },
    {
      id: 11,
      logo: "job-search/1.jpg",
      job_name: "UI/UX IT Frontend Developer",
      badgeType: "primary",
      badgeValue: "New",
      job_area: "(L6) Salt Lake City",
      job_city: "UT",
      Job_description:
        "We are looking for an experienced and koho designer and/or frontend engineer with expertise in accessibility to join our team , 3+ years of experience working in as a Frontend Engineer or comparable role. You won’t be a team of one though — you’ll be collaborating coely with other...",
      type: "new",
      ribbion: false,
    },
    {
      id: 12,
      logo: "job-search/2.jpg",
      job_name: "React/React Native Developer",
      badgeType: "primary",
      badgeValue: "New",
      job_area: "San Diego",
      job_city: "CA",
      Job_description:
        "deally 2+ years experience with React. Bonus points if you have React Native experience. This is an incredibly exciting opportunity to gain commercial , Professional experience of React Native and other front end frameworks. Transform product wireframes into responsive, mobile user interface",
      type: "new",
      ribbion: false,
    },
    {
      id: 13,
      logo: "job-search/4.jpg",
      job_name: "Front end web developer",
      badgeType: "primary",
      badgeValue: "New",
      job_area: "Cisco",
      job_city: "Lelystad, Netherlands",
      Job_description:
        "The designer will apply Lean UX and Design Thinking practices in a highly collaborative, fast-paced, distributed environment You have 4+ years of UX experience. You support UX leadership by providing continuous feedback regarding the evolution of team process standards",
      type: "3 days ago",
      ribbion: false,
    },
    {
      id: 14,
      logo: "job-search/3.jpg",
      job_name: "Senior UX designer",
      badgeType: "secondary",
      badgeValue: "New",
      job_area: "Minneapolis",
      job_city: "MN",
      Job_description:
        "We are looking for an experienced and zeta designer and/or frontend engineer with expertise in accessibility to join our team , 3+ years of experience working in as a Frontend Engineer or comparable role.",
      type: "2 days ago",
      ribbion: true,
    },
  ];

  export const Months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December",];

  export const daysData = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20", "21", "22", "23", "24", "25", "26", "27", "28", "29", "30", "31",];

  export const yearsData = ["1985", "1986", "1987", "1988", "1989", "1990", "1991", "1992", "1993", "1994", "1995", "1996", "1997", "1998", "1999", "2000", "2001", "2002", "2003", "2004", "2005", "2006", "2007", "2008", "2009", "2010", "2011", "2012", "2013", "2014", "2015",];

  export const typeHeadOptions = ["Student", "Bachelor", "Master", "Associate"];


  export const positionsData = ["Web Designer", "Graphic Designer", "UI Designer", "UI/UX Designer",];

  export const jobDetailData = [
    {
        header:"Qualifications",
        detail:[
           "Have shipped multiple iOS, Android, and/or web products",
            "5+ years UI/UX experience",
            "Portfolio demonstrating mastery of native iOS, Android, and/or responsive web design principles",
            "Ability to autonomously pursue elegant solutions to open-ended problems",
            "Comfort with ambiguity",
            "Proven ability to create interactive prototypes",
            "Strong verbal communication skills with ability to clearly communicate complex ideas and champion a design vision across all levels of an organization",
            "Strong written communication skills with ability to make transparent design documentation and client-facing presentations",
            "Ability to create and maintain flow charts, wire frames, prototypes, and mockups.",
            "Ability to effectively work on more than one project at a time",
            "Experience conducting user research and stakeholder interviews",
            "Solid grasp of standard design tools, ex: Sketch, Omnigraffle, the Adobe Suite, Zeplin, etc.",
            "Bonus Considerations"
        ]
    },
    {
        header:"Agency experience",
        detail:[
           "Experience working with Agile development teams",
            "Experience with RITE method usability testing",
            "Experience in visual and motion design; ability to translate UX design into high quality visuals",
            "Mastery of Sketch & InVision",
            "Knowledge of mobile or front-end web programming"
        ]
    },
    {
        header:"Perks",
        detail:[
           "Competitive pay",
            "Competitive medical, dental, and vision insurance plans",
            "Company-provided 401(k) plan",
            "Paid vacation and sick time",
            "Free snacks and beverages"
        ]
    }
]